import { useEffect, useState } from "react";
import { fetchMarketingAnalytics, fetchUserJourneyDetail, searchMarketingVisitor, fetchMarketingFunnel } from "../../../services/api";
import UserJourneyDrawer from "../UserJourneyDrawer";
import MarketingOverview from "../marketing/MarketingOverview";
import VisitorsBySourceChart from "../marketing/VisitorsBySourceChart";
import PaymentsBySourceChart from "../marketing/PaymentsBySourceChart";
import ConversionRanking from "../marketing/ConversionRanking";
import AnalyticsRankingCard from "../cards/AnalyticsRankingCard";
import MarketingFunnel from "../marketing/MarketingFunnel";
import MarketingFunnelFilters from "../marketing/MarketingFunnelFilters";
import MarketingVisitorCard from "../marketing/MarketingVisitorCard";


const MarketingTab = () => {
    const [marketing, setMarketing] = useState(null);
    const [loading, setLoading] = useState(true);
    const [filters, setFilters] = useState({ search: "", utm_source: "", utm_campaign: "", user_type: "", paid: "" });
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [journey, setJourney] = useState(null);
    const [searchedVisitor, setSearchedVisitor] = useState(undefined);
    const [funnel, setFunnel] = useState(null);
    const loadFunnel = async (payload) => {
        const response = await fetchMarketingFunnel(payload);
        if (response.status === 1) {
            setFunnel(response.data);
        }
    };
    useEffect(() => {
        load();
    }, []);

    useEffect(() => {
        loadFunnel(filters);
    }, [
        filters.search,
        filters.utm_source,
        filters.utm_campaign,
        filters.user_type,
        filters.paid,
    ]);

    const updateFilter = async (key, value) => {

        if (key === "search") {
            const newFilters = {
                ...filters,
                search: value,
            };

            setFilters(newFilters);
            if (!value.trim()) {
                const newFilters = {
                    ...filters,
                    search: "",
                };
                setFilters(newFilters);
                setSearchedVisitor(undefined);
                return;
            }
            const response = await searchMarketingVisitor(value);
            if (response.status === 1) {
                setSearchedVisitor(response.data || null);
            }
            return;
        }
        const newFilters = {
            ...filters,
            [key]: value,
        };
        setFilters(newFilters);
    };

    const resetFilters = () => {
        setSearchedVisitor(undefined);
        setFilters({
            search: "",
            utm_source: "",
            utm_campaign: "",
            user_type: "",
            paid: "",
        });
    };

    const openJourney = async (visitor) => {
        const response = await fetchUserJourneyDetail(visitor.visitor_id);
        if (response.status === 1) {
            setJourney(response.data);
            setDrawerOpen(true);
        }
    };

    const load = async () => {
        try {
            const response = await fetchMarketingAnalytics();
            if (response.status === 1) {
                setMarketing(response.data);
            }
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="flex flex-col items-center justify-center gap-3 py-20">
                <div className="h-8 w-8 animate-spin rounded-full border-2 border-indigo-600 border-t-transparent" />
                <p className="text-sm text-gray-500">Loading marketing analytics...</p>
            </div>
        );
    }

    return (
        <div className="space-y-5">
            <MarketingFunnelFilters
                filters={filters}
                options={funnel?.filter_options || {}}
                onChange={updateFilter}
                onReset={resetFilters}
            />
            <MarketingFunnel data={funnel?.marketing_funnel} />
            <MarketingVisitorCard visitor={searchedVisitor} onViewJourney={openJourney} />
            <MarketingOverview summary={marketing.summary} />

            <div className="grid gap-4 xl:grid-cols-2">
                <VisitorsBySourceChart data={marketing.source_conversion} />
                <PaymentsBySourceChart data={marketing.source_conversion} />
            </div>

            <ConversionRanking data={marketing.source_conversion} />

            <div className="grid gap-4 xl:grid-cols-2">
                <AnalyticsRankingCard
                    title="Campaign Performance"
                    subtitle="Successful payments by campaign"
                    data={marketing.campaign_conversion}
                    labelKey="campaign"
                    valueKey="payments"
                    accent="violet"
                />
                <AnalyticsRankingCard
                    title="Visitor Entry Pages"
                    subtitle="Where visitors started their journey"
                    data={marketing.landing_pages}
                    labelKey="page"
                    valueKey="visitors"
                    accent="sky"
                />
            </div>

            <div className="grid gap-4 xl:grid-cols-2">
                <AnalyticsRankingCard
                    title="Traffic Acquisition Channels"
                    subtitle="Grouped by UTM medium"
                    data={marketing.utm_mediums}
                    labelKey="medium"
                    valueKey="visitors"
                    accent="amber"
                />
                <AnalyticsRankingCard
                    title="External Referrals"
                    subtitle="Visitors arriving from other websites"
                    data={marketing.referrers}
                    labelKey="referrer"
                    valueKey="visitors"
                    accent="rose"
                />
            </div>


            <UserJourneyDrawer
                open={drawerOpen}
                journey={journey}
                onClose={() => setDrawerOpen(false)}
            />
        </div>
    );
};

export default MarketingTab;